import {cleanEntity} from "@mytour/platform";
import type {DepartureAddressResponse, UpdateDepartureAddressPayload} from "@mytour/shared";
import axios from "axios";

export const departureAddressApiService = {
  async getDepartureAddress(): Promise<DepartureAddressResponse> {
    const result = await axios.get<DepartureAddressResponse>(
      "api/platform-users/billing/departure-address/"
    );
    return result.data;
  },

  async updateDepartureAddress(
    payload: UpdateDepartureAddressPayload
  ): Promise<DepartureAddressResponse> {
    const result = await axios.post<DepartureAddressResponse>(
      "api/platform-users/billing/departure-address/",
      cleanEntity(payload)
    );
    return result.data;
  },
};
